import React, { useEffect, useRef, useState } from 'react'
import './admin-game-view.styles.scss';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { format } from 'date-fns';
import AdminGameViewButtons from './admin-game-buttons.component';
import AdminGameData from './admin-game-data.component';
import AdminDataView from './admin-game-data.component';
import { getGameElementsFromRtDb, getPlayerDataFromDb, getPlayersFromPlayerDocs } from '@/utils/getDataFromDb';
import { off } from 'firebase/database';
import ElementDataView from './element-data-view.component';

const AdminGameView = ({
  games,
  owners
}) => {

  const { gameId } = useParams();
  const [ gameData, setGameData ] = useState(null);
  const [ owner, setOwner ] = useState(null);
  const [ view, setView ] = useState('gameData');
  const [ gameElements, setGameElements ] = useState({}); 
  const [ gamePlayers, setGamePlayers ] = useState({});
  const elementsRef = useRef();
  const playersRef = useRef();
  const dataReceivedRef = useRef(false);
  const navigate = useNavigate();
  let elementsListener;
  let playersListener;

  useEffect(() => {

    return () => {
      if (elementsListener) off(elementsListener);
      if (playersListener) off(playersListener);
    }
  }, [])

  useEffect(() => {
    if (!games || !gameId) return;
    const game = games[gameId];
    if (!game) return;
    setGameData(games[gameId]);
    if (owners && owners[game.creatorId]) {
      setOwner(owners[game.creatorId]);
    }
    if (!dataReceivedRef.current) {
      dataReceivedRef.current = true;
      getGameData();
    }
  }, [games, gameId, owners])

  function getGameData() {
    getGameElementsFromRtDb({
      'gameId': gameId,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      if (!data) return;
      // elementsRef.current = {
      //   ...elementsRef.current,
      //   ...{[data.id]: data}
      // }
      setGameElements(data);
    }
    function handleListener(unsub) {
      elementsListener = unsub;
    }
    getPlayersFromPlayerDocs({
      'gameId': gameId,
      'once': true,
      'callback': callback2,
      'handleListener': handleListener2
    })
    function callback2(data) {
      let tempList = {...playersRef.current};
      for (let p of Object.values(data)) {
        if (p.status !== 'active') {
            if (tempList[p.playerId]) {
                delete tempList[p.playerId];
            }
        } else {
            tempList[p.playerId] = p;
        }
      }
      playersRef.current = {...tempList};
      setGamePlayers(playersRef.current);
    }
    function handleListener2(unsub) {
      playersListener = unsub;
    }

  }

  return (
    <div className='admin-game-view'>
      <div className='g-card game-card'>
        <BackButton cancel={() => navigate(-1)} />
        <div className="g-space-1"></div>
        {
          (gameData) &&
          <div className='game-content'>
            <div className='card-title with-button'>
              <ImageContainer
                src={gameData.icon}
                className='head-icon' />
              {gameData.gameName}
              <div className='meta game-info-head'>
                <div>
                  Owner: {
                    owner ? `${owner.fName} ${owner.lName}` : 'Unknown'
                  }
                </div> 
                Last Activity: {format(new Date(gameData.ts), "Pp")}
              </div>
            </div>
            <hr />
            <Routes>
              <Route path='' element={
                <div className='game-view-grid'>
                  <AdminGameViewButtons
                    view={view}
                    setView={setView} />
                  {
                    (view) &&
                    (
                      (view === 'gameData')
                      ?
                      <AdminDataView
                        view={view}
                        dataToDisplay={[gameData]} />
                      :
                      (view === 'elements' && gameElements)
                      ?
                      <AdminDataView
                        view={view}
                        dataToDisplay={Object.values(gameElements)} />
                      :
                      (view === 'players' && gamePlayers)
                      ?
                      <AdminDataView
                        view={view}
                        dataToDisplay={Object.values(gamePlayers)} />
                      :
                      <div></div>
                    )
                  }
                </div>}></Route>
                <Route path=":elementId" element={
                  <ElementDataView
                    gameElements={gameElements}
                    gamePlayers={gamePlayers} />
                }></Route>
              </Routes>
          </div>
        }
      </div>
    </div>
  )
}

export default AdminGameView